<nz-upload [nzShowButton]="files.length<1" [nzFileList]="files" (nzChange)="uploadChange($event)"
                (nzFileListChange)="fileListChange($event)" nzListType="picture-card" [nzLimit]="limit"
                [nzAccept]="imageFileType"
                [nzFileType]="imageFileType"
                [nzSize]="1000"
                [nzRemove]="onRemove"
                [nzAction]="uploadUrl">
                <i nz-icon nzType="plus"></i>
                <div class="ant-upload-text">上传</div>
</nz-upload>